import { Box, Typography, Container, Link as LinkMUI, useMediaQuery } from '@mui/material';
import Image from 'next/image';
import logo from '../../public/icons/logo.png';
import { ArrowForwardRounded } from '@mui/icons-material';
import { useTheme } from '@mui/styles';

const Nav = () => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <>
      <Box height={68}></Box>
      <Box
        bgcolor="white"
        height={68}
        mb={3}
        className="mui-fixed"
        sx={{
          boxShadow: '0px 0px 32px rgba(0, 0, 0, 0.06)',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1100, // https://material-ui.com/customization/z-index/
          display: 'flex',
          alignItems: 'center',
        }}>
        <Container>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Box>
              <LinkMUI target="_blank" href={process.env.NEXT_PUBLIC_SITES_VEEVA_URL}>
                <Image src={logo} unoptimized alt="veeva site vault logo" />
              </LinkMUI>
            </Box>

            <Typography variant="body1" color="primary">
              <LinkMUI
                target="_blank"
                href={process.env.NEXT_PUBLIC_SITES_VEEVA_URL}
                underline="none"
                sx={(theme) => {
                  return {
                    color: theme.palette.primary.main,
                    '&:hover': {
                      color: theme.palette.primary.main,
                      opacity: 0.8,
                    },
                  };
                }}>
                Learn more {mdUp && ' about SiteVault'}
                <ArrowForwardRounded fontSize="small" sx={{ position: 'relative', top: 3 }} />
              </LinkMUI>
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default Nav;
